import React, { useState, useEffect } from 'react';
import { Link, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import api from '../utils/api';
import { BtnPrimary, Card, Tag, Pill, FormGroup, inputStyle } from '../components/ui';

function Sidebar() {
  const loc = useLocation();
  const links = [
    { path: '/admin', label: '📊 Dashboard', exact: true },
    { path: '/admin/articles', label: '📝 Articles' },
    { path: '/admin/contacts', label: '📬 Messages' },
    { path: '/admin/news', label: '📰 News & Events' },
    { path: '/admin/videos', label: '🎬 Videos' },
    { path: '/admin/gallery', label: '🖼 Gallery' },
  ];
  return (
    <div style={{ width: 250, background: 'var(--dark)', color: 'white', padding: 24, position: 'fixed', top: 0, bottom: 0, overflowY: 'auto' }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24, color: 'white' }}>
        <img src="/logo.png" alt="Wijdan" style={{ width: 36, height: 36, objectFit: 'contain' }} /><h2 className="serif" style={{ margin: 0, fontSize: '1.3rem', color: 'var(--saffron)' }}>Wijdan Admin</h2>
      </Link>
      {links.map(l => (
        <Link key={l.path} to={l.path} style={{
          display: 'block', padding: '10px 14px', borderRadius: 8, color: 'rgba(255,255,255,.7)', marginBottom: 4, transition: 'all .2s',
          background: (l.exact ? loc.pathname === l.path : loc.pathname.startsWith(l.path)) ? 'rgba(232,133,26,.2)' : 'transparent',
        }}>{l.label}</Link>
      ))}
      <div style={{ marginTop: 40, paddingTop: 20, borderTop: '1px solid rgba(255,255,255,.1)' }}>
        <a href="/" target="_blank" rel="noopener noreferrer" style={{ display: 'block', padding: '10px 14px', color: 'rgba(255,255,255,.7)' }}>🌐 View Website</a>
        <button onClick={async () => { await api.post('/auth/logout'); window.location.href = '/admin'; }} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 14px', background: 'none', border: 'none', color: '#f87171', cursor: 'pointer', fontFamily: "'Outfit',sans-serif", fontSize: 14 }}>🚪 Logout</button>
      </div>
    </div>
  );
}

function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get('/stats/admin').then(r => setStats(r.data)).catch(() => {}); }, []);
  const items = [
    { label: 'Pending Articles', value: stats.pendingArticles },
    { label: 'Total Articles', value: stats.totalArticles },
    { label: 'Unread Messages', value: stats.unreadContacts },
    { label: 'Poets', value: stats.totalPoets },
    { label: 'Books', value: stats.totalBooks },
  ];
  return (
    <div>
      <h2 className="serif" style={{ fontSize: '2rem', marginBottom: 24 }}>Dashboard</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 20, marginBottom: 32 }}>
        {items.map((s, i) => (
          <Card key={i} style={{ padding: 24, textAlign: 'center' }}>
            <div className="serif" style={{ fontSize: '2.5rem', fontWeight: 700, color: 'var(--saffron)' }}>{s.value ?? '-'}</div>
            <div style={{ fontSize: 13, color: 'var(--brown)', marginTop: 4 }}>{s.label}</div>
          </Card>
        ))}
      </div>
      <Card style={{ padding: 24 }}>
        <h3 style={{ marginBottom: 12 }}>Quick Actions</h3>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Link to="/admin/articles"><BtnPrimary style={{ padding: '8px 18px', fontSize: 13 }}>Review Articles</BtnPrimary></Link>
          <Link to="/admin/contacts"><BtnPrimary style={{ padding: '8px 18px', fontSize: 13, background: 'var(--brown)' }}>View Messages</BtnPrimary></Link>
          <Link to="/admin/news"><BtnPrimary style={{ padding: '8px 18px', fontSize: 13, background: 'var(--gold)' }}>Manage News</BtnPrimary></Link>
        </div>
      </Card>
    </div>
  );
}

function AdminArticles() {
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState('all');
  const load = () => api.get('/articles/admin/all', { params: { status: filter } }).then(r => setArticles(r.data)).catch(() => {});
  useEffect(() => { load(); }, [filter]);
  const action = async (id, act) => { await api.put(`/articles/${id}/${act}`); load(); };
  const del = async (id) => { if (window.confirm('Delete?')) { await api.delete(`/articles/${id}`); load(); } };

  return (
    <div>
      <h2 className="serif" style={{ fontSize: '2rem', marginBottom: 24 }}>Articles</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {['all', 'pending', 'published', 'rejected'].map(s => <Pill key={s} active={filter === s} onClick={() => setFilter(s)}>{s}</Pill>)}
      </div>
      <Card style={{ padding: 0, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>{['Title', 'Author', 'Category', 'Status', 'Actions'].map(h => <th key={h} style={{ padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid rgba(232,133,26,.08)', fontSize: 14, fontWeight: 600, color: 'var(--brown)', background: 'var(--soft-orange)' }}>{h}</th>)}</tr></thead>
          <tbody>
            {articles.map(a => (
              <tr key={a.id}>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(232,133,26,.05)', fontWeight: 500, maxWidth: 250 }}>{a.title}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(232,133,26,.05)', fontSize: 13 }}>{a.author_name}<br /><span style={{ color: '#999', fontSize: 11 }}>{a.author_email}</span></td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(232,133,26,.05)' }}><Tag type={a.category}>{a.category}</Tag></td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(232,133,26,.05)' }}>
                  <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: a.status === 'pending' ? '#FEF3C7' : a.status === 'published' ? '#D1FAE5' : '#FEE2E2', color: a.status === 'pending' ? '#92400E' : a.status === 'published' ? '#065F46' : '#991B1B' }}>{a.status}</span>
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(232,133,26,.05)', whiteSpace: 'nowrap' }}>
                  {a.status === 'pending' && <>
                    <button onClick={() => action(a.id, 'approve')} style={{ background: '#16a34a', color: 'white', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, marginRight: 4 }}>Approve</button>
                    <button onClick={() => action(a.id, 'reject')} style={{ background: '#DC2626', color: 'white', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, marginRight: 4 }}>Reject</button>
                  </>}
                  <button onClick={() => action(a.id, 'feature')} style={{ background: 'var(--soft-orange)', color: 'var(--brown)', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, marginRight: 4 }}>{a.featured ? '★' : '☆'}</button>
                  <button onClick={() => del(a.id)} style={{ background: '#FEE2E2', color: '#991B1B', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>Del</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!articles.length && <p style={{ textAlign: 'center', padding: 40, color: '#999' }}>No articles found.</p>}
      </Card>
    </div>
  );
}

function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  useEffect(() => { api.get('/contacts').then(r => setContacts(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h2 className="serif" style={{ fontSize: '2rem', marginBottom: 24 }}>Messages</h2>
      {contacts.map(c => (
        <Card key={c.id} style={{ padding: 20, marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <div><strong>{c.name}</strong>{c.email && <span style={{ color: '#999', fontSize: 13 }}> · {c.email}</span>}</div>
            <span style={{ fontSize: 12, color: '#999' }}>{new Date(c.created_at).toLocaleString()}</span>
          </div>
          <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--brown)' }}>{c.message}</p>
        </Card>
      ))}
      {!contacts.length && <Card style={{ padding: 40, textAlign: 'center' }}><p style={{ color: '#999' }}>No messages yet.</p></Card>}
    </div>
  );
}

function AdminNews() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: '', description: '', event_date: '', type: 'News', emoji: '📰' });
  const load = () => api.get('/news').then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => { if (!form.title || !form.event_date) return; await api.post('/news', form); setForm({ title: '', description: '', event_date: '', type: 'News', emoji: '📰' }); load(); };
  const del = async (id) => { if (window.confirm('Delete?')) { await api.delete(`/news/${id}`); load(); } };

  return (
    <div>
      <h2 className="serif" style={{ fontSize: '2rem', marginBottom: 24 }}>News & Events</h2>
      <Card style={{ padding: 24, marginBottom: 24 }}>
        <h3 style={{ marginBottom: 16 }}>Add New</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <FormGroup label="Title"><input style={inputStyle} value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} /></FormGroup>
          <FormGroup label="Date"><input style={inputStyle} value={form.event_date} onChange={e => setForm({ ...form, event_date: e.target.value })} placeholder="May 15, 2026" /></FormGroup>
          <FormGroup label="Type"><select style={inputStyle} value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}><option>News</option><option>Event</option></select></FormGroup>
          <FormGroup label="Emoji"><input style={inputStyle} value={form.emoji} onChange={e => setForm({ ...form, emoji: e.target.value })} /></FormGroup>
        </div>
        <FormGroup label="Description"><textarea style={{ ...inputStyle, minHeight: 80 }} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></FormGroup>
        <BtnPrimary onClick={add} style={{ padding: '8px 18px', fontSize: 13 }}>Add</BtnPrimary>
      </Card>
      {items.map(n => (
        <Card key={n.id} style={{ padding: 16, marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div><span style={{ fontSize: 24, marginRight: 12 }}>{n.emoji}</span><strong>{n.title}</strong> <Tag style={{ marginLeft: 8 }}>{n.type}</Tag> <span style={{ fontSize: 12, color: '#999', marginLeft: 8 }}>{n.event_date}</span></div>
          <button onClick={() => del(n.id)} style={{ background: '#DC2626', color: 'white', border: 'none', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>Delete</button>
        </Card>
      ))}
    </div>
  );
}

function AdminVideos() {
  const [videos, setVideos] = useState([]);
  const [form, setForm] = useState({ video_id: '', title: '', description: '' });
  const load = () => api.get('/videos').then(r => setVideos(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => { if (!form.video_id || !form.title) return; await api.post('/videos', form); setForm({ video_id: '', title: '', description: '' }); load(); };
  const del = async (id) => { if (window.confirm('Delete?')) { await api.delete(`/videos/${id}`); load(); } };

  return (
    <div>
      <h2 className="serif" style={{ fontSize: '2rem', marginBottom: 24 }}>YouTube Videos</h2>
      <Card style={{ padding: 24, marginBottom: 24 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <FormGroup label="Video ID"><input style={inputStyle} value={form.video_id} onChange={e => setForm({ ...form, video_id: e.target.value })} placeholder="dQw4w9WgXcQ" /></FormGroup>
          <FormGroup label="Title"><input style={inputStyle} value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} /></FormGroup>
        </div>
        <FormGroup label="Description"><input style={inputStyle} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></FormGroup>
        <BtnPrimary onClick={add} style={{ padding: '8px 18px', fontSize: 13 }}>Add Video</BtnPrimary>
      </Card>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 16 }}>
        {videos.map(v => (
          <Card key={v.id} style={{ padding: 0 }}>
            <img src={`https://img.youtube.com/vi/${v.video_id}/hqdefault.jpg`} alt={v.title} style={{ width: '100%', aspectRatio: '16/9', objectFit: 'cover' }} />
            <div style={{ padding: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div><strong style={{ fontSize: 14 }}>{v.title}</strong><br /><span style={{ fontSize: 12, color: '#999' }}>ID: {v.video_id}</span></div>
              <button onClick={() => del(v.id)} style={{ background: '#DC2626', color: 'white', border: 'none', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>Del</button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

function AdminGallery() {
  const [items, setItems] = useState([]);
  const load = () => api.get('/gallery').then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const del = async (id) => { if (window.confirm('Delete?')) { await api.delete(`/gallery/${id}`); load(); } };

  return (
    <div>
      <h2 className="serif" style={{ fontSize: '2rem', marginBottom: 24 }}>Gallery</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 16 }}>
        {items.map(g => (
          <Card key={g.id} style={{ padding: 0 }}>
            <div style={{ aspectRatio: '1', background: g.image_url ? `url(${g.image_url}) center/cover` : g.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2.5rem' }}>{!g.image_url && g.emoji}</div>
            <div style={{ padding: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 13, fontWeight: 500 }}>{g.title}</span>
              <button onClick={() => del(g.id)} style={{ background: '#DC2626', color: 'white', border: 'none', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11 }}>Del</button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

// Login
function LoginPage({ onLogin }) {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const submit = async () => {
    try {
      await api.post('/auth/login', form);
      onLogin();
    } catch { setError('Invalid credentials'); }
  };
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--cream)', padding: 20 }}>
      <Card style={{ padding: 40, maxWidth: 400, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}><img src="/logo.png" alt="Wijdan" style={{ width: 80, height: 80, objectFit: 'contain', margin: '0 auto' }} /><h2 className="serif" style={{ fontSize: '1.8rem', marginTop: 8 }}>Wijdan Admin</h2></div>
        {error && <div style={{ padding: '12px 16px', borderRadius: 10, background: '#FEE2E2', color: '#991B1B', marginBottom: 16, fontSize: 14 }}>{error}</div>}
        <FormGroup label="Username"><input style={inputStyle} value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} /></FormGroup>
        <FormGroup label="Password"><input type="password" style={inputStyle} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} onKeyDown={e => e.key === 'Enter' && submit()} /></FormGroup>
        <BtnPrimary onClick={submit} style={{ width: '100%', justifyContent: 'center' }}>Login</BtnPrimary>
        <p style={{ textAlign: 'center', marginTop: 16 }}><Link to="/" style={{ color: 'var(--saffron)', fontSize: 14 }}>← Back to Website</Link></p>
      </Card>
    </div>
  );
}

// Main Admin wrapper
export default function AdminPage() {
  const [authed, setAuthed] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/auth/check').then(r => setAuthed(r.data.isAdmin)).catch(() => setAuthed(false));
  }, []);

  if (authed === null) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>;
  if (!authed) return <LoginPage onLogin={() => setAuthed(true)} />;

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <div style={{ marginLeft: 250, padding: 32, flex: 1, minHeight: '100vh', background: 'var(--cream)' }}>
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="articles" element={<AdminArticles />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="news" element={<AdminNews />} />
          <Route path="videos" element={<AdminVideos />} />
          <Route path="gallery" element={<AdminGallery />} />
        </Routes>
      </div>
      <style>{`@media(max-width:768px) { div[style*="margin-left: 250px"] { margin-left: 0 !important; } }`}</style>
    </div>
  );
}
